import {
  Breadcrumb,
  Button,
  ButtonProps,
  Col,
  Flex,
  Form,
  FormProps,
  Row,
  Space,
  Typography,
} from 'antd';
import { ItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { SCROLL_OPTIONS } from 'screens/stakeholders/helper';
import { isMobileScreenSize } from 'utils/helpers';
import './mobile.css';
import './style.css';

type FormContainerProps = FormProps & {
  title: React.ReactNode;
  onCancel?: () => void;
  children?: React.ReactNode;
  breadcrumbItems?: ItemType[];
  submitBtnProps?: ButtonProps;
  draftBtnProps?: ButtonProps;
  cancelBtnProps?: ButtonProps;
  cancelBtnText?: React.ReactNode;
  draftBtnText?: React.ReactNode;
  submitBtnText?: React.ReactNode;
  extraContent?: React.ReactNode;
};

const FormContainer = ({
  title,
  onCancel,
  breadcrumbItems,
  submitBtnProps,
  cancelBtnProps,
  cancelBtnText,
  submitBtnText,
  draftBtnProps,
  draftBtnText,
  children,
  extraContent,
  ...restProps
}: FormContainerProps) => {
  return (
    <Form
      className="form-container"
      labelWrap
      scrollToFirstError={SCROLL_OPTIONS}
      {...restProps}
    >
      {breadcrumbItems ? (
        <Breadcrumb className="form-breadcrumb" items={breadcrumbItems} />
      ) : null}
      <Flex className="form-header" justify="space-between">
        <Typography.Title level={3}>{title}</Typography.Title>
      </Flex>

      {extraContent}

      <Space
        className="form-space"
        direction="vertical"
        size={isMobileScreenSize ? 'small' : 'middle'}
      >
        {children}
      </Space>

      <Row className="mobile-footer" justify="space-between" gutter={[8, 10]}>
        <Col span={24}>
          <Button type="primary" htmlType="submit" {...submitBtnProps}>
            {submitBtnText ?? 'Submit'}
          </Button>
        </Col>

        {draftBtnProps && (
          <Col span={24}>
            <Button onClick={draftBtnProps?.onClick} {...draftBtnProps}>
              {draftBtnText ?? 'Save for Later'}
            </Button>
          </Col>
        )}

        <Col span={24}>
          <Button
            onClick={cancelBtnProps?.onClick || onCancel}
            {...cancelBtnProps}
          >
            {cancelBtnText ?? 'Cancel'}
          </Button>
        </Col>
      </Row>

      <Flex className="form-header" justify="space-between" gap={8}>
        {draftBtnProps && (
          <Button
            {...draftBtnProps}
            htmlType="button"
            onClick={draftBtnProps?.onClick}
          >
            {draftBtnText ?? 'Save for Later'}
          </Button>
        )}

        <Flex gap={8} align="center">
          <Button
            onClick={cancelBtnProps?.onClick || onCancel}
            {...cancelBtnProps}
          >
            {cancelBtnText ?? 'Cancel'}
          </Button>
          <Button type="primary" htmlType="submit" {...submitBtnProps}>
            {submitBtnText ?? 'Submit'}
          </Button>
        </Flex>
      </Flex>
    </Form>
  );
};

export default FormContainer;
